import { valueLabels } from './projectBaseApi';

export const scheduleDate = date => date ? new Date(`${date}T00:00:00Z`).toLocaleDateString('es-BO', {
  timeZone: 'UTC', day: '2-digit', month: 'short', year: 'numeric'
}) : 'Sin fecha';

// The dashboard owns the selection and date range. Records only enrich its sessions.
export function projectSchedule(data, records) {
  const sessionsById = new Map((records.session || []).map(s => [s.id, s]));
  return data.timeline.map(activity => ({
    ...activity,
    sessions: activity.sessions.map(session => ({ ...sessionsById.get(session.id), ...session }))
      .sort((a, b) => `${a.date} ${a.startTime || ''}`.localeCompare(`${b.date} ${b.startTime || ''}`))
  }));
}

export const sessionStatus = session => valueLabels[session.status] || session.status || 'Sin estado';
export const sessionTime = session => `${session.startTime || 'Por confirmar'} - ${session.endTime || 'Por confirmar'}`;
